import { useEffect, useState } from "react";

export const useTabVisibility = (): DocumentVisibilityState => {
    // forces re-rendering
    const [changedTabVisibility, setChangedTabVisibility] = useState<DocumentVisibilityState>("visible");

    const handleVisibilityChange = () => {
        setChangedTabVisibility(document.visibilityState);
    };

    useEffect(() => {
        // add the event listener
        document.addEventListener("visibilitychange", handleVisibilityChange);

        // remove the event listener
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, []);

    return changedTabVisibility;
};
